export const PAGINATION_STYLES = {
  '& .MuiPaginationItem-root': {
    color: '#b0b0b0',
    backgroundColor: '#2a2a2a',
    border: '1px solid #444',
    borderRadius: '50%',
    minWidth: '40px',
    height: '40px',
    width: '40px',
    '&:hover': {
      backgroundColor: '#ffa900',
      color: '#000',
      fontWeight: 600,
    },
    '&.Mui-selected': {
      backgroundColor: '#ffa900',
      color: '#000',
      fontWeight: 600,
    },
  },
}
